<template>
  <div class="slider-popup">
    <div class="slider-wrapper flex center">
      <div class="slider-small-icon">
        <span class="button-menu-icon mr-5" :class="config.icon" v-if="config.icon"></span>
      </div>

      <input
        ref="range"
        type="range"
        v-model="currentValue"
        @input="onInput"
        @change="onChange"
        :min="config.min"
        :max="config.max"
        :step="config.step || 1"
      >
      <div class="slider-tooltip ml-5" ref="tooltip">{{currentValueString}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Slider',
  components: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.currentValue = this.config.value
  },
  beforeUpdate() {},
  updated() {
  },
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      currentValue: 0
    }
  },
  props: {
    config: {
      type: Object
    }
  },
  computed: {
    currentValueString() {
      const symbol = Math.floor(this.currentValue) > 0 ? '+' : ''
      return `${symbol}${this.currentValue}`
    }
  },
  methods: {
    onInput(evt) {
      this.$emit('input', { type: this.config.type, value: this.currentValue })
    },
    onChange() {
      this.$emit('change', { type: this.config.type, value: this.currentValue })
    }
  },
  watch: {
    config(newVal, oldVal) {
      this.currentValue = newVal.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/slider/Slider.vue